import store from '@/store'
import router from '@/router'
import ModalConfirmReload from '@/components/ui/modals/ModalConfirmReload.vue'

export async function checkVersion() {
  const versionKey = 'appVersion';
  const currentVersion = localStorage.getItem(versionKey);
  try {
    const res = await fetch('/version.json?_=' + Date.now())
    const data = await res.json()
    if (data.version && currentVersion !== data.version) {
      localStorage.setItem(versionKey, data.version);
      const isFirstVisit = !currentVersion;
      const isAuthPage = router.currentRoute.path.startsWith('/auth');
      if (!isFirstVisit && !isAuthPage) {
        store.dispatch('ModalModule/open', {
          extends: ModalConfirmReload,
        })
      }
    }
  } catch (e) {
    console.error('Version check error', e)
  }
}
